/** Country dial codes used on signup. Lengths are national digits after dropping a leading 0. */
export const PHONE_COUNTRIES = [
  { iso: 'DZ', dial: '213', flag: '🇩🇿', minLength: 9, maxLength: 9, example: '055 12 34 56 78' },
  { iso: 'FR', dial: '33', flag: '🇫🇷', minLength: 9, maxLength: 9, example: '06 12 34 56 78' },
  { iso: 'MA', dial: '212', flag: '🇲🇦', minLength: 9, maxLength: 9, example: '0612 345678' },
  { iso: 'TN', dial: '216', flag: '🇹🇳', minLength: 8, maxLength: 8, example: '20 123 456' },
  { iso: 'EG', dial: '20', flag: '🇪🇬', minLength: 9, maxLength: 10, example: '010 1234 5678' },
  { iso: 'SA', dial: '966', flag: '🇸🇦', minLength: 9, maxLength: 9, example: '051 234 5678' },
  { iso: 'AE', dial: '971', flag: '🇦🇪', minLength: 9, maxLength: 9, example: '050 123 4567' },
  { iso: 'TR', dial: '90', flag: '🇹🇷', minLength: 10, maxLength: 10, example: '0500 123 4567' },
  { iso: 'BE', dial: '32', flag: '🇧🇪', minLength: 8, maxLength: 9, example: '0470 12 34 56' },
  { iso: 'ES', dial: '34', flag: '🇪🇸', minLength: 9, maxLength: 9, example: '612 34 56 78' },
  { iso: 'IT', dial: '39', flag: '🇮🇹', minLength: 9, maxLength: 10, example: '312 345 6789' },
  { iso: 'DE', dial: '49', flag: '🇩🇪', minLength: 10, maxLength: 11, example: '0151 23456789' },
  { iso: 'GB', dial: '44', flag: '🇬🇧', minLength: 10, maxLength: 10, example: '07400 123456' },
  { iso: 'CA', dial: '1', flag: '🇨🇦', minLength: 10, maxLength: 10, example: '(514) 555-0123' },
  { iso: 'US', dial: '1', flag: '🇺🇸', minLength: 10, maxLength: 10, example: '(415) 555-2671' }
];

export const DEFAULT_PHONE_COUNTRY = 'DZ';

export function getPhoneCountry(iso) {
  return PHONE_COUNTRIES.find((country) => country.iso === iso) || PHONE_COUNTRIES[0];
}

export function digitsOnly(value) {
  return String(value || '').replace(/\D/g, '');
}

function nationalCore(digits, country) {
  if (
    digits.startsWith('0') &&
    digits.length - 1 >= country.minLength &&
    digits.length - 1 <= country.maxLength
  ) {
    return digits.slice(1);
  }
  return digits;
}

export function toE164(iso, nationalNumber) {
  const country = getPhoneCountry(iso);
  const core = nationalCore(digitsOnly(nationalNumber), country);
  return core ? `+${country.dial}${core}` : '';
}

export function isValidPhone(iso, nationalNumber) {
  const country = getPhoneCountry(iso);
  const core = nationalCore(digitsOnly(nationalNumber), country);
  return core.length >= country.minLength && core.length <= country.maxLength;
}

/** If the user pasted +213... match the longest dial code and split country / national number. */
export function parseInternationalInput(value) {
  const trimmed = String(value || '').trim();
  if (!trimmed.startsWith('+')) return null;

  const digits = digitsOnly(trimmed);
  const sorted = [...PHONE_COUNTRIES].sort((a, b) => b.dial.length - a.dial.length);
  const match = sorted.find((country) => digits.startsWith(country.dial));
  if (!match) return null;

  return {
    iso: match.iso,
    national: digits.slice(match.dial.length)
  };
}
